/**
 * How a section of the offering catalog is captioned and keyed.
 *
 * Its own module because both the chip row and the grid need it, and neither is
 * a natural owner: putting it beside either component makes the other import a
 * component file for a string helper, and gives that file two reasons to change.
 */

/** The caption for a section whose offerings name no owning service. */
export const UNKNOWN_SERVICE_LABEL = "No owning service";

export function sectionLabel(namespace: string | null): string {
  return namespace ?? UNKNOWN_SERVICE_LABEL;
}

/**
 * A stable key for a section, including the one whose namespace is absent.
 *
 * Distinct from the label on purpose: a service literally named "No owning
 * service" would collide with the fallback section's caption, while it cannot
 * collide with this.
 */
export function sectionKey(namespace: string | null): string {
  return namespace ?? "__none__";
}
